import { render, staticRenderFns } from "./MySupport.vue?vue&type=template&id=4bf69e72&scoped=true&"
import script from "./MySupport.vue?vue&type=script&lang=js&"
export * from "./MySupport.vue?vue&type=script&lang=js&"
import style0 from "./MySupport.vue?vue&type=style&index=0&id=4bf69e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf69e72",
  null
  
)

export default component.exports